import React__default, { forwardRef } from 'react';
import { ListItemPrefixWrapper, ImagePlaceholder } from './styles.js';

const ListItemPrefix = forwardRef(({ variant, prefix }, ref) => {
    switch (prefix.type) {
        case 'thumbnail':
        case 'avatar':
            return (React__default.createElement(ListItemPrefixWrapper, { variant: variant, type: prefix.type, ref: ref }, prefix.img ? (React__default.createElement("img", { src: prefix.img })) : (React__default.createElement(ImagePlaceholder, { type: prefix.type }))));
        case 'action':
        case 'icon':
        default:
            return (React__default.createElement(ListItemPrefixWrapper, { variant: variant, type: prefix.type, ref: ref }, prefix.element));
    }
});

export { ListItemPrefix };
